import React from 'react';
import { H4 } from './H4';

export const H4C100 = (props) => <H4 colorStep={100} {...props} />;
